<template>
  <layout-main-inner title="需求管理">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <!-- <ent-auto-select
          v-model="config.vendorId"
          style="margin-right: 10px"
          :callback="()=> { handleCurrentChange(1) }" /> -->
        <el-radio-group
          v-model="config.status"
          @change="handleCurrentChange(1)">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="0">待受理</el-radio-button>
          <el-radio-button :label="1">受理中</el-radio-button>
          <el-radio-button :label="2">完成</el-radio-button>
          <el-radio-button :label="9">拒绝</el-radio-button>
        </el-radio-group>
        <el-input
          v-model="config.servName"
          style="margin-left: 10px;width: 250px"
          clearable
          placeholder="请输入服务名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="服务名称"
          fixed="left"
          min-width="140"
          prop="servName"> </el-table-column>
        <el-table-column
          label="机构名称"
          min-width="120"
          prop="servOrgName"></el-table-column>
        <el-table-column
          label="受理人"
          width="100"
          prop="staffName"></el-table-column>
        <el-table-column
          label="企业信息"
          min-width="160"
          prop="contactMan">
          <template slot-scope="{ row }">
            {{ row.vendorName }}- {{ row.contactMan }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="70">
          <template slot-scope="{ row }">
            {{ row.status | ConsultStatusName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="提交时间"
          width="150">
          <template slot-scope="{ row }">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="85">
          <template slot-scope="{ row }">
            <div>
              <el-button
                type="text"
                @click="showDetail(row)">查看</el-button>
              <el-button
                type="text"
                @click="deleteitem(row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <detail-drawer ref="detail" />
  </layout-main-inner>
</template>
<script>
import DetailDrawer from './detail-drawer.vue'
// import { mapState } from 'vuex'
// import UserSelectModal from './user-select-modal.vue'
// import EntAutoSelect from '../../components/ent-auto-select.vue'
export default {
  name: 'RequirementsIndex',
  components: { DetailDrawer },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: { pageNum: 1, pageSize: 10, vendorId: null, status: null }
    }
  },
  // computed: {
  //   ...mapState({
  //     userInfo: (state) => state.account.userInfo
  //     // menuData: (state) => state.account.menu,
  //     // permission: (state) => state.account.permission
  //   })
  //   // accept() {
  //   //   const func = this.menuData.find(o => o.menuId === 1058) || {}
  //   //   const item = (func.children || []).find(o => o.funcId === 135) || {}
  //   //   return (item.operations || []).findIndex(i => i.operation === 'accept') > -1
  //   // },
  //   // assign() {
  //   //   const func = this.menuData.find(o => o.menuId === 1058) || {}
  //   //   const item = (func.children || []).find(o => o.funcId === 135) || {}
  //   //   return (item.operations || []).findIndex(i => i.operation === 'assign') > -1
  //   // }
  // },
  mounted() {
    this.fetchList()
  },
  methods: {
    showDetail(row) {
      this.$refs.detail.fetch({ id: row.id })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该需求?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$OrgService.deleteservconsult({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    // assignitem(row) {
    //   this.$refs.select.fetch(row)
    // },
    // createitem(row) {
    //   console.log(row)
    //   this.$refs.acceptance.add({
    //     inspectionNeedId: row.inspectionNeedId,
    //     vendorId: row.vendorId,
    //     vendorName: row.vendorName,
    //     serviceId: row.serviceId,
    //     classId: [row.classId]
    //   })
    // },
    acceptinspectionneed(row) {
      // this.$prompt('请输入不受理原因', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputPattern: /.+/,
      //   inputErrorMessage: '请输入不受理原因'
      // }).then(({ value }) => {
      //   this.loading = true
      //   this.$store.dispatch('account/notacceptinspectionneed', {
      //     payload: {
      //       inspectionNeedId: row.inspectionNeedId,
      //       acceptInfo: value
      //     },
      //     success: () => {
      //       this.loading = false
      //       this.fetchList()
      //     },
      //     fail: () => {
      //       this.loading = false
      //     }
      //   })
      // })
      this.$confirm('您确定受理该需求?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('account/acceptinspectionneed', {
            payload: { inspectionNeedId: row.inspectionNeedId },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$$OrgService.getservconsults({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0, 13].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
      // this.loading = true
      // this.$store.dispatch('account/getinspectionneeds', {
      //   payload: this.config,
      //   success: (res) => {
      //     this.loading = false
      //     this.totalNum = res.data.total
      //     this.list = res.data.records
      //   },
      //   fail: () => {
      //     this.loading = false
      //   }
      // })
    }
  }
}
</script>
